import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ChevronDownIcon } from '@heroicons/react/24/outline'
import ProSelection from '../Elements/ProSelection'

export default function CatalogoPage() {
  const { t } = useTranslation('catalogo')
  return (
    <div>
      <header className="relative isolate flex min-h-screen flex-col items-center justify-center overflow-hidden bg-gradient-to-br from-navy-900 to-navy-950 px-6 pb-24 pt-28 text-center">
        {/* fondo: puntos, resplandores y anillos */}
        <div
          className="pointer-events-none absolute inset-0 -z-10 opacity-[0.07]"
          style={{ backgroundImage: 'radial-gradient(circle, rgb(255, 255, 255) 1px, transparent 1px)', backgroundSize: '28px 28px' }}
          aria-hidden="true"
        />
        <div className="pointer-events-none absolute -left-40 top-10 -z-10 h-[34rem] w-[34rem] rounded-full bg-electric-500/30 blur-3xl" aria-hidden="true" />
        <div className="pointer-events-none absolute -right-32 bottom-0 -z-10 h-[30rem] w-[30rem] rounded-full bg-neon-300/15 blur-3xl" aria-hidden="true" />
        <div className="pointer-events-none absolute left-1/2 top-1/2 -z-10 h-[46rem] w-[46rem] -translate-x-1/2 -translate-y-1/2 rounded-full border border-white/5" aria-hidden="true" />
        <div className="pointer-events-none absolute left-1/2 top-1/2 -z-10 h-[64rem] w-[64rem] -translate-x-1/2 -translate-y-1/2 rounded-full border border-white/[0.04]" aria-hidden="true" />

        <span className="inline-block rounded-full border border-neon-300/50 bg-neon-300/10 px-4 py-1.5 text-xs font-medium uppercase tracking-[0.15em] text-neon-300">
          {t('hero.badge')}
        </span>
        <h1 className="mt-6 text-5xl font-extrabold tracking-wide text-white sm:text-7xl">
          PRO <span className="text-neon-300">SELECTION</span>
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-lg leading-8 text-white/70 sm:text-xl">{t('hero.subtitle')}</p>

        <div className="mt-9 flex flex-wrap items-center justify-center gap-4">
          <a href="#almacenes" className="rounded-md bg-neon-300 px-6 py-3 text-sm font-semibold text-navy-900 shadow-sm transition hover:bg-neon-400 sm:text-base">
            {t('hero.ctaPrimary')} <span aria-hidden="true">&darr;</span>
          </a>
          <Link to="/contact" state="cotizar-equipo" className="rounded-md border border-white/30 px-6 py-3 text-sm font-semibold text-white transition hover:bg-white/10 sm:text-base">
            {t('hero.ctaSecondary')} <span aria-hidden="true">&rarr;</span>
          </Link>
        </div>

        <p className="mt-10 text-sm italic text-electric-200">{t('hero.tagline')}</p>

        <a href="#almacenes" aria-label={t('hero.ctaPrimary')} className="absolute bottom-6 left-1/2 -translate-x-1/2 text-white/50 transition hover:text-neon-300">
          <ChevronDownIcon className="h-7 w-7 animate-bounce" />
        </a>
      </header>

      <div className="pt-10">
        <ProSelection />
      </div>
    </div>
  )
}
